module.exports = __webpack_public_path__ + "img/ps-13.891d047c.jpg";